import React, {useState, useEffect, useRef} from 'react';
import {useRouter} from 'next/router';
import {useSelector, useDispatch} from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import {fetchProfile} from '../login/userSlice';
import LoadingFullPage from './LoadingFullPage';

const AuthScreen = (props) => {

    const {redirectUrl, goBackPage} = props;

    const user = useSelector(state => state.user );
    const router = useRouter();
    const dispatch = useDispatch();
    const isMounted = useRef(null);

    const {message, closeLoading} = props;

    useEffect( ()=>{
        
        isMounted.current = true;
        if (!user.isLoggedIn) {
            checkProfile();
        } else {
            closeLoading();
        }

        return () => {
            isMounted.current = false;
        }
    }, []);

    
    const redirectLogin = (isLoggedIn) => {
        if (!isLoggedIn) {
            let url = redirectUrl ? redirectUrl : '/login';
            if (goBackPage) {
                url += `?redirect=${goBackPage}`;
            }
            router.push(url);  
        } else {
            closeLoading();
        }
    }

    const checkProfile = async () => {
        try {
            const resultAction = await dispatch(fetchProfile());
            const response = unwrapResult(resultAction);
            redirectLogin(response.status);
        } catch (e) {
            // 401 (not authenticated) or request failure -> treat as logged out
            redirectLogin(false);
        }
    }

    return (
        <LoadingFullPage message={message} />
    );
}

export default AuthScreen;